import { Frame } from 'dragonmouse-shared/interfaces';
import { combineReducers } from 'redux';
import dbReducer, { selectFrames } from './db/reducers';
import modeReducer from './mode/reducers';

const rootReducer = combineReducers({
	db: dbReducer,
	mode: modeReducer,
});

export default rootReducer;

export type RootReducer = ReturnType<typeof rootReducer>;

//------------------------------------------------------------------------------------------------
// Derived state selectors that span multiple slices
//------------------------------------------------------------------------------------------------

export const selectSelectedFrames = (rootReducer: RootReducer) => {
	const frames = selectFrames(rootReducer.db);
	return rootReducer.mode.selected.reduce((selectedFrames, pick) => {
		if (pick.isFrame()) {
			const selectedFrame = frames.find((f) => f.id === pick.frameId);
			if (selectedFrame) selectedFrames.push(selectedFrame);
		}
		return selectedFrames;
	}, [] as Frame[]);
};

// New semantic loading selectors
export const selectIsAppReady = ({ db }: RootReducer): boolean => {
	// App is ready when user and scenes are loaded
	return db.loading.profile === 'loaded' && db.loading.scenes === 'loaded';
};

export const selectIsActiveSceneReady = ({ db }: RootReducer): boolean => {
	// Active scene is ready when frames are loaded (chats can still be loading)
	return db.loading.activeScene.frames === 'loaded';
};

// This will give a nice global loading state. We can make future ones that only
// care about certain subsets of the data.
export const selectIsLoadingAnything = ({ db, mode }: RootReducer): boolean => {
	// If the user is not logged in, we are loading
	// This works with the way we have studio set up to redirect away if the user
	// is signed out. So if this is null, that means we are waiting for user info
	// to be loaded.
	// ??? : do we need to check authUser here -- if we haven't loaded user, app won't be ready
	//       i am already doing a big change right now and am reluctant to push further with my cleanup
	//       so not digging in right now - ss
	if (!mode.authUser) return true;

	if (mode.activeSceneId) {
		if (db.sceneLoadError !== null) return false;

		// When a scene is active, we are loading until app is ready AND active scene is ready
		return !selectIsAppReady({ db, mode }) || !selectIsActiveSceneReady({ db, mode });
	} else {
		// When no scene is active, we are loading if app is not ready
		return !selectIsAppReady({ db, mode });
	}
};
